import { createReducer, createAction, createSelector } from 'redux-starter-kit';
import { find } from 'ramda';

export interface UserType {
  uuid: string;
  created_at: string;
  updated_at: string;
  terms_agreement: boolean;
  organizations: string;
  email: string;
  first_name: string;
  last_name: string;
  username: string;
  language: string;
  phone: string;
  role: number;
}

// State
interface UsersState {
  list: UserType[];
  count: number | null;
  next: string | null;
  previous: string | null;
}

export const initialState: UsersState = {
  list: [],
  count: null,
  next: null,
  previous: null,
};

// Actions
const GET_USERS = 'projects/GET_USERS';

const getUserUsers = createAction(GET_USERS);

export const projectsActions = {
  getUserUsers,
};

// Selectors
export const projectsSelectors = {
  users: createSelector(['users.list']),
  selectUserById: (userUuid: string) =>
    createSelector(['users.list'], (users) =>
      find((user: UserType) => user.uuid === userUuid)(users)
    ),
};

// Reducers
export default createReducer(initialState, {
  [GET_USERS]: (state, action) => {
    state.list = action.payload.results;
    state.count = action.payload.count;
    state.next = action.payload.next;
    state.previous = action.payload.previous;
  },
});
